/* global angular, moment */
(function () {
  'use strict';

  angular
    .module('vcfinance.privcat')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcfinanceprivcat', {
        url: '/financeprivcat',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;privcatsearch privcat="" privcatref=""  hideaddoption="true" onselectcb="&"&gt;</tt></h3><div ui-view="privcatsearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;privcatsearch privcat="" privcatref="" editinplace="true" hideaddoption="true"&gt;</tt></h3><div ui-view="privcatsearchview3"></div>
              <h3 class="alert alert-info"><tt>&lt;privcatysearch privcat="" privcatref="" parentsave=""&gt;</tt></h3><div ui-view="privcatsearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;privcatentryeditor privcat="" onClose=""&gt;</tt></h3><div ui-view="privcateditview"></div>
              <h3 class="alert alert-info"><tt>&lt;privcatnewentry&gt;</tt></h3><div ui-view="privcatnewentryview"></div>
              <h3 class="alert alert-info"><tt>&lt;privcatnewgroup&gt;</tt></h3><div ui-view="privcatnewgroupview"></div>
              <h3 class="alert alert-info"><tt>&lt;privcatentrylist privcatentries="?"&gt;</tt></h3><div ui-view="privcatentrylistview"></div>
              <h3 class="alert alert-info"><tt>&lt;privcatgrouplist privcatgroups="?"&gt;</tt></h3><div ui-view="privcatgrouplistview"></div>
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.financevcprivcat entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcfinanceprivcat.allcomponents', {
        url: '/allcomponents',
        resolve: {
          privcat: function () {
            return '';
          },
          privcatref: function () {
            return '';
          },
          someprivcat: function (Privcat) {
            return Privcat.$find('572b31b07c01597e3e150923');
          },
          allprivcats: function (Privcat) {
            return Privcat.$search({active: true});
          },
          parentsavesearch: function () {
            return function (privcat, privcatref) {
              console.log('debug: dummy parentsave called for privcatsearch with: ', privcat, privcatref);
            };
          },
          eip: function () {
            return true;
          },
          eipf: function () {
            return false;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'privcatsearchview@playground.vcfinanceprivcat': {
            component: 'privcatsearch',
            bindings: {
              privcat: 'privcat',
              privcatref: 'privcatref',
              editinplace: 'eipf',
              hideaddoption: 'eip'
            }
          },
          'privcatsearchview2@playground.vcfinanceprivcat': {
            component: 'privcatsearch',
            bindings: {
              privcat: 'privcat',
              privcatref: 'privcatref',
              parentsave: 'parentsavesearch',
              editinplace: 'eip'
            }
          },
          'privcatsearchview3@playground.vcfinanceprivcat': {
            component: 'privcatsearch',
            bindings: {
              privcat: 'privcat',
              privcatref: 'privcatref',
              parentsave: 'parentsavesearch',
              editinplace: 'eip',
              hideaddoption: 'eip'
            }
          },
          'privcateditview@playground.vcfinanceprivcat': {
            component: 'privcatentryeditor',
            bindings: {

            }
          },
          'privcatnewentryview@playground.vcfinanceprivcat': {
            component: 'privcatnewentry',
            bindings: {
            }
          },
          'privcatnewgroupview@playground.vcfinanceprivcat': {
            component: 'privcatnewgroup',
            bindings: {
            }
          },
          'privcatentrylistview@playground.vcfinanceprivcat': {
            component: 'privcatentrylist',
            bindings: {

            }
          },
          'privcatgrouplistview@playground.vcfinanceprivcat': {
            component: 'privcatgrouplist',
            bindings: {
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcfinanceprivcat.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






